// src/Pages/DashboardManagment/moduleMap.js
// import InventoryDashboard from "./InventoryDashboard";
// import StaffDashboard from "./StaffDashboard";
// export const MODULE_COMPONENTS = {
//   "Lead Management": null,             
//   "inventoryManagement": InventoryDashboard,
//   "staff-management": StaffDashboard,

// };
// src/Pages/DashboardManagment/moduleMap.js
import InventoryDashboard from "./InventoryDashboard";
import StaffDashboard from "./StaffDashboard";
import HRMSDashboard from "./HRMSDashboard";
import BulkSMSDashboard from "./BulkSMSDashboard";
import RCSDashboard from "./RCSDashboard";
import AMCDashboard from "./AMCDashboard";

export const MODULE_COMPONENTS = {
  // Core
  "Lead Management": null, 
  "staff-management": StaffDashboard,
  "inventoryManagement": InventoryDashboard,

  "chat": null,
  "reminder": null,
  "meeting": null,
  "enquiry": null,
  "calendar": null,
  "leave": null,
  "bulk-sms": BulkSMSDashboard,
  "rcs": RCSDashboard,
  "hrms": HRMSDashboard,

  "amc": AMCDashboard,

  "paymentlsit": null,
  "paymentgatway": null,
  "apiProvider": null,
  "cloud&devops": null,
  "content-setting": null,
};
